import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchNewBetaJoinerRequest } from "../../store/Dashboard/dashboardAction";
import SimpleBar from "simplebar-react";
import im1 from "../../assets/images/1.avif";
import im2 from "../../assets/images/2.avif";
import im3 from "../../assets/images/3.avif";
import im4 from "../../assets/images/4.avif";
import im5 from "../../assets/images/5.avif";
import im6 from "../../assets/images/6.avif";
import im7 from "../../assets/images/7.avif";
import im8 from "../../assets/images/8.avif";
import im10 from "../../assets/images/10.avif";
import im11 from "../../assets/images/11.avif";
import im12 from "../../assets/images/12.avif";
import im13 from "../../assets/images/13.avif";
import im14 from "../../assets/images/14.avif";

// Array of images to be displayed
const images = [im1, im2, im3, im4, im5, im6, im7, im8, im10, im11, im12, im13, im14];

const GetLAtestBetaSubsciber = () => {
    const [data, setData] = useState("");
    const [selectedDays, setSelectedDays] = useState(1);

    const dispatch = useDispatch(); 
    const { data: newBetaJoiner } = useSelector(
        (state) => state.newBetaJoiner
    );

    useEffect(() => {
        dispatch(fetchNewBetaJoinerRequest(selectedDays));
    }, [dispatch,selectedDays]);

    useEffect(() => {
        if (newBetaJoiner !== undefined) {
            setData(newBetaJoiner)
        }
    }, [newBetaJoiner]);

    const handleSelectChange = (event) => {
        const days = parseInt(event.target.value, 10);
        setSelectedDays(days);
    };

    return (
        <React.Fragment>
            <Col lg={4}>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <select
                                className="form-select form-select-sm"
                                value={selectedDays}
                                onChange={handleSelectChange}
                            >
                                <option value={1}>24 hrs</option>
                                <option value={3}>3 Days</option>
                                <option value={7}>7 Days</option>
                            </select>
                        </div>

                        <h4 className="card-title mb-4 mt-2">Latest Beta Subscriber</h4>
                        <hr className='mb-1' />
                        <SimpleBar style={{ maxHeight: "339px" }}>
                            <ul className="list-unstyled">
                                {data.androidCount && data.androidCount.map((item, index) => {
                                    const imageIndex = index % images.length;
                                    return (
                                        <li className=" border-bottom" style={{padding:"10px"}} key={index}>
                                            <div className="d-flex align-items-center">
                                                <img src={images[imageIndex]} alt={`Subscriber ${index + 1}`} style={{ width: '40px', height: '40px', borderRadius: '50%' }} className="me-3" />
                                                <div>
                                                    <div className='mb-1' style={{ fontSize: "16px",opacity:'0.9' }}>{item.email}</div>
                                                    <div style={{ fontSize: "12px", color: 'grey' }}>{item.isAndroid ? "Android Beta" : "iOS Beta"}</div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </SimpleBar>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default GetLAtestBetaSubsciber;
